import React from "react";

import { useCartStore } from "../state/cartStore";

const CartContext = React.createContext();

const CartProvider = ({ children }) => {
  const store = useCartStore();

  return <CartContext.Provider value={store}>{children}</CartContext.Provider>;
};

export default CartContext;
export { CartProvider, useCartStore };
